import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
const PURCHASE_CTAS = new Set([
    'PRO_UPGRADE',
    'ADD_CREDITS',
    'EXPRESS_ADD_CREDITS',
    'COMPUTER_TRIAL_OFFER',
    'SUBSCRIPTION_PROMO',
    'ADVANCED_SEARCH_CHECKOUT',
    'COMET_DOWNLOAD_1MO_PRO_INCENTIVE',
]);
export function isCtaEnabledForDeployment(cta) {
    if (!BUILD_CAPABILITIES.payments && PURCHASE_CTAS.has(cta))
        return false;
    return BUILD_CAPABILITIES.studentVerification || cta !== 'OPEN_SHEERID_MODAL';
}
//# sourceMappingURL=ctaCapabilities.js.map